import raghdacell from "../../images/projects/raghdacell1.jpg";
import gkgallery from "../../images/projects/gkgallery.jpg";
import qiranbook from "../../images/projects/qiranbook.jpg";
import primePixels from "../../images/projects/prime-pixels.jpg";
import erpsInstitutes from "../../images/projects/erps-institutes.jpg";
export const dataProjects = [
  {
    id: 1,
    main: raghdacell,
    link: "https://www.raghdacell.com",
  },
  {
    id: 2,
    main: gkgallery,
    link: "https://gkgallery.com",
  },
  {
    id: 3,
    main: qiranbook,
    link: "https://www.qiranbook.com/",
  },
  {
    id: 4,
    main: primePixels,
    link: "https://prime-pixels.com/",
  },
  {
    id: 5,
    main: erpsInstitutes,
    link: "https://erps-institutes.vercel.app/",
  },
];
